'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _isNan = require('babel-runtime/core-js/number/is-nan');

var _isNan2 = _interopRequireDefault(_isNan);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WarningProperty = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(WarningProperty, _Component);

  function WarningProperty(props) {
    (0, _classCallCheck3.default)(this, WarningProperty);

    var _this = (0, _possibleConstructorReturn3.default)(this, (WarningProperty.__proto__ || (0, _getPrototypeOf2.default)(WarningProperty)).call(this, props));

    _this.showMoreInsideThisToggle = function () {
      return _this.setState(function (prevState) {
        return {
          showMoreInsideThis: !prevState.showMoreInsideThis
        };
      });
    };

    _this.state = {
      showMoreInsideThis: false
    };
    return _this;
  }

  (0, _createClass3.default)(WarningProperty, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.onUpdate) {
        this.props.onUpdate();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          cutoffs = _props.cutoffs,
          value = _props.value,
          rawValue = _props.rawValue,
          formatting = _props.formatting,
          fieldName = _props.fieldName,
          hoverText = _props.hoverText,
          normalFormatting = _props.normalFormatting,
          extendedInfo = _props.extendedInfo,
          alwaysShow = _props.alwaysShow;
      var showMore = this.props.showMore;
      var showMoreInsideThis = this.state.showMoreInsideThis;


      if (rawValue === undefined || typeof rawValue === 'number' && (0, _isNan2.default)(rawValue)) {
        return null;
      }

      var colorName = 'default';
      var wholeDivColor = 'default';

      if (cutoffs && !normalFormatting) {
        if (cutoffs.good(value)) {
          colorName = 'success';
        } else if (cutoffs.warning(value)) {
          colorName = 'warning';
        } else {
          colorName = 'danger';
          wholeDivColor = 'danger';
          showMore = true;
        }
      }

      if (alwaysShow) {
        showMore = true;
      }

      var expansionSymbol = '';
      if (extendedInfo) {
        expansionSymbol = showMoreInsideThis ? '– ' : '+ ';
      }

      return showMore && _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'span',
          {
            className: 'text-' + wholeDivColor,
            title: hoverText,
            onClick: this.showMoreInsideThisToggle
          },
          _react2.default.createElement(
            'strong',
            null,
            expansionSymbol + fieldName
          ),
          ' : ',
          _react2.default.createElement(
            'span',
            { className: 'text-' + colorName },
            formatting(value)
          )
        ),
        showMoreInsideThis && extendedInfo
      );
    }
  }]);
  return WarningProperty;
}(_react.Component), _class.propTypes = {
  showMore: _react.PropTypes.bool,
  cutoffs: _react.PropTypes.object,
  value: _react.PropTypes.any,
  rawValue: _react.PropTypes.any,
  formatting: _react.PropTypes.func,
  fieldName: _react.PropTypes.string,
  hoverText: _react.PropTypes.string,
  normalFormatting: _react.PropTypes.bool,
  extendedInfo: _react.PropTypes.object,
  alwaysShow: _react.PropTypes.bool,
  onUpdate: _react.PropTypes.func
}, _temp);
exports.default = WarningProperty;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/WarningProperty/WarningProperty.js
 ** module id = 1388
 ** module chunks = 0
 **/